import { Box, Button } from "@mui/material"
import { makeStyles } from "tss-react/mui-compat"
import { FloatingBottomButton } from "components/floating-bottom-button"
import React from "react"
import Sticky from "react-stickynode"

const useStyles = makeStyles()(
  (_theme) => ({
    buttonRoot: {
      width: "100%",
    },
  }),
)

interface StickyRightColumnProps {
  ctaButtonText?: string
  ctaButtonDisabled?: boolean
  onCtaPress?: () => void
  children?: React.ReactNode
  headerComponent?: React.ReactNode
}

export const StickyRightColumn = (props: StickyRightColumnProps) => {
  const { ctaButtonText, onCtaPress, children, headerComponent, ctaButtonDisabled } = props
  const { classes } = useStyles()

  return (
    <>
      <div className="join-session-button">
        {/*@ts-ignore children type error occurs because of upgrading to React 18*/}
        <Sticky enabled={false}>
          <Box display="flex" flexDirection="column" pl={[4]} maxWidth={["100%", "100%", "300px"]}>
            {!!headerComponent && headerComponent}

            {Boolean(ctaButtonText) && (
              <Box display="flex" mt={[3]} justifyContent="space-between" alignItems="center">
                <Button
                  classes={{ root: classes.buttonRoot }}
                  onClick={onCtaPress}
                  color="primary"
                  variant="contained"
                  disabled={ctaButtonDisabled}
                  size="large">
                  {ctaButtonText}
                </Button>
              </Box>
            )}
            {children}
          </Box>
        </Sticky>
      </div>
      {Boolean(ctaButtonText) && (
        <div className="floating-join-session-button">
          <FloatingBottomButton
            buttonText={ctaButtonText}
            onPress={onCtaPress}
            buttonDisabled={ctaButtonDisabled}
          />
        </div>
      )}
      {/* @ts-ignore */}
      <style jsx>{`
        .join-session-button {
          display: none;
          float: right;
        }

        .floating-join-session-button {
          display: block;
        }

        @media screen and (min-width: 1024px) {
          .join-session-button {
            display: block;
          }
          .floating-join-session-button {
            display: none;
          }
        }
      `}</style>
    </>
  )
}
